import React, { useEffect, useState } from 'react'
import DataLegalAndRegTexts from './DataLegalAndRegTexts'
import { LegalAndRegTextInterface, DefaultLegalAndRegTextInterface, ShowLegalAndRegTextsContext } from './types'
import AddLegalAndRegText from './AddLegalAndRegText'
import SuccessMsg from '../../Messages/SuccessMsg'
import EditLegalAndRegText from './EditLegalAndRegText'
import DeleteLegalAndRegText from './DeleteLegalAndRegText'
import { FaChevronCircleLeft, FaPlus } from 'react-icons/fa'
import { useNavigate } from 'react-router'
import { useDispatch } from 'react-redux'
import { getLegalAndRegTextApi } from '../../redux/legal_and_regulator_text/legalAndRegulatorTextApiCalls'
import ShowDocuments from './ShowDocuments'

const ShowLegalAndRegTexts:React.FC = () => {
  const [showSuccessMsg, setShowSuccessMsg] = useState(false)
  const [showEditModal, setShowEditModal] = useState(false)
  const [showAddModal, setShowAddModal] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [showDocumentsModal, setShowDocumentsModal] = useState(false)
  const [selectedLegalAndRegText, setSelectedLegalAndRegText] = useState<LegalAndRegTextInterface>(DefaultLegalAndRegTextInterface)
  const [selectedDoctor, setSelectedDoctor] = useState<any[]>([]);
  const [hideDataLegalAndRegText, setHideDataLegalAndRegText] = useState(false)
  const navigate = useNavigate()

  const dispatch: any = useDispatch();

  useEffect(() => {
    const fetchAss = async () => {
      await dispatch(getLegalAndRegTextApi());
    };
    fetchAss();
  }, [dispatch]);


  return (
    <ShowLegalAndRegTextsContext.Provider value={{
      showSuccessMsg, setShowSuccessMsg,
      showEditModal, setShowEditModal,
      showDeleteModal, setShowDeleteModal,
      selectedLegalAndRegText, setSelectedLegalAndRegText,
      selectedDoctor, setSelectedDoctor,
      hideDataLegalAndRegText, setHideDataLegalAndRegText,
      showAddModal, setShowAddModal,
      showDocumentsModal, setShowDocumentsModal
    }}>
      {showSuccessMsg && <SuccessMsg modal={showSuccessMsg} toggle={() => setShowSuccessMsg(!showSuccessMsg)}/> }

      {showAddModal && <AddLegalAndRegText modal={showAddModal} toggle={() => setShowAddModal(!showAddModal)} /> }
      
      <div className="flex justify-start gap-2 mt-2">
        <FaChevronCircleLeft style={{ fontSize: "30px" }} className="text-main" onClick={() => navigate("/")}/>
        <button className="p-2 rounded btn-main" onClick={() => setShowAddModal(!showAddModal)}>
          <FaPlus />
        </button>
      </div>
      <DataLegalAndRegTexts />
      {showEditModal && selectedLegalAndRegText?._id && <EditLegalAndRegText LegalAndRegTextData={selectedLegalAndRegText} modal={showEditModal}  toggle={() => setShowEditModal(!showEditModal)} />}
      {showDeleteModal && selectedLegalAndRegText?._id && <DeleteLegalAndRegText LegalAndRegTextData={selectedLegalAndRegText} modal={showDeleteModal}  toggle={() => setShowDeleteModal(!showDeleteModal)} />}
      {showDocumentsModal && selectedLegalAndRegText?._id && 
        <ShowDocuments modal={showDocumentsModal} toggle={() => setShowDocumentsModal(!setShowDocumentsModal)} />
      }
    </ShowLegalAndRegTextsContext.Provider>
  )
}

export default ShowLegalAndRegTexts
